'use client';

import { Badge } from '@/components/ui/badge';

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'bg-muted text-muted-foreground' },
  active: { label: 'Active', className: 'bg-green-500/10 text-green-600' },
  paused: { label: 'Paused', className: 'bg-yellow-500/10 text-yellow-600' },
  archived: { label: 'Archived', className: 'bg-red-500/10 text-red-600' },
  scheduled: { label: 'Scheduled', className: 'bg-blue-500/10 text-blue-600' },
  dispatching: { label: 'Dispatching', className: 'bg-blue-500/10 text-blue-600' },
  in_progress: { label: 'In Progress', className: 'bg-yellow-500/10 text-yellow-600' },
  completed: { label: 'Completed', className: 'bg-green-500/10 text-green-600' },
  failed: { label: 'Failed', className: 'bg-red-500/10 text-red-600' },
  skipped: { label: 'Skipped', className: 'bg-muted text-muted-foreground' },
};

interface RoutineStatusBadgeProps {
  status: string;
}

export function RoutineStatusBadge({ status }: RoutineStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || { label: status, className: 'bg-muted text-muted-foreground' };

  return (
    <Badge variant="secondary" className={config.className}>
      {config.label}
    </Badge>
  );
}
